import smoothScroll from '@plugins/smooth-scroll';

export default () => {
  $(document)
    // This JS event gets triggered before FacetWP begins the refresh process.
    //
    // It happens before any AJAX is requested, and before the URL hash gets updated.
    // This event is useful for modifying any FWP variables before getting sent to the server.
    .on('facetwp-refresh', () => {
      window.packbackLoading.addEvent('facetwp-refresh', true);
    })
    // This JS event gets triggered when FacetWP finishes refreshing.
    //
    // It’s triggered after a user interacts with a facet or pagination control.
    // This event is useful for modifying facet output after being rendered.
    .on('facetwp-loaded', () => {
      window.packbackLoading.endEvent('facetwp-refresh');
    })
    // Smooth scroll to top of results on pagination click
    .on('click', '.facetwp-pager a', (e) => {
      e.preventDefault();
      smoothScroll($('.facetwp-scroll-target').offset().top - 40, false);
    })
  ;
};
